import { Component } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NzDatePickerModule } from "ng-zorro-antd/date-picker";
import { DateRangePickerComponent } from "../common/date-range-picker/date-range-picker.component";
import { ChipInputComponent } from "../common/chip-input/chip-input.component";

@Component({
  selector: "app-dynamic-form-poc",
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    NzDatePickerModule,
    DateRangePickerComponent,
    ChipInputComponent
  ],
  templateUrl: "./dynamic-form-poc.component.html",
  styleUrl: "./dynamic-form-poc.component.scss"
})
export class DynamicFormPocComponent {
  dateRange: [Date, Date] | null = null;

  constructor() {
  }

  onDateRangeChange($event: [Date, Date] | null) {
    console.log('Date range changed:', $event);
    this.dateRange = $event;
  }

  onChange($event: any) {

  }
}
